rdefine('app/products/properties/Boolean',['backbone'],function(Backbone) {
    var idLocalUsedToBuild = 0;
    return Backbone.Ribs.View.extend({
        tagName:'div',
        bindings:{
            label:{
                text:'model.name'
            },
            input: {

            }
        },
        initialize:function(options) {
            this.$el.html('<div class="checkbox">\n' +
                '                                    <input type="checkbox" id="local_checkbox_id_used_for_check_'+(++idLocalUsedToBuild)+'" value="true"/>\n' +
                '                                    <i class="input-helper"></i>\n' +
                '                                    <label for="local_checkbox_id_used_for_check_'+(idLocalUsedToBuild)+'" style="display:inline;"></label>\n' +
                '                                </div>');
            this.$el.css("margin-top","7px");
            this.cform = options.cform;
            this.bindings.input.checked = 'cform.property_'+this.model.get("id");
        }
    });
});